import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import App from "./App";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Eleve from "./pages/Eleve";
import Prof from "./pages/Prof";
import Admin from "./pages/Admin";
import Gratuit from "./pages/Gratuit";
import RequireAuth from "./components/RequireAuth";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // <— nécessaire pour le collapse

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      children: [
        { index: true, element: <Home /> },
        { path: "login", element: <Login /> },
        { path: "login-prof", element: <Navigate to="/login" replace /> },
        { path: "gratuit", element: <Gratuit /> },
        {
          path: "eleve",
          element: (
            <RequireAuth role="eleve">
              <Eleve />
            </RequireAuth>
          ),
        },
        {
          path: "prof",
          element: (
            <RequireAuth role="prof">
              <Prof />
            </RequireAuth>
          ),
        },
        {
          path: "admin",
          element: (
            <RequireAuth role="admin">
              <Admin />
            </RequireAuth>
          ),
        },
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ],
  {
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
